import { render } from "./MainCreditNoteSale.vue?vue&type=template&id=2ffd1c2a&scoped=true"
import script from "./MainCreditNoteSale.vue?vue&type=script&lang=js"
export * from "./MainCreditNoteSale.vue?vue&type=script&lang=js"

import "./MainCreditNoteSale.vue?vue&type=style&index=0&id=2ffd1c2a&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffd1c2a"]])

export default __exports__